import * as React from 'react';
import { View } from 'react-native';

import { Text } from '@/components/ui/text';
import { SetupLayout } from '@/features/setup/components/setup-layout';
import { useSetupContext } from '@/features/setup/setup-provider';

const STEP = 1;

export function WelcomeScreen() {
  const { advance, isAdvancing } = useSetupContext();

  return (
    <SetupLayout
      step={STEP}
      primaryLabel="Get started"
      onPrimary={advance}
      primaryLoading={isAdvancing}
    >
      <View className="flex-1 items-center justify-center">
        <View className="mb-12 items-center">
          <Text className="mb-2 text-4xl font-bold text-foreground">Flavrly</Text>
          <Text className="text-center text-lg text-muted-foreground">Eat Like a Local</Text>
        </View>

        <Text className="px-4 text-center text-base text-muted-foreground">
          Discover dishes worth trying, track where you&apos;ve been, and share your favorites with
          friends.
        </Text>
      </View>
    </SetupLayout>
  );
}
